"use client";

import { MousePointerClick, UserPlus, Trophy, Gift } from "lucide-react";
import { Card, CardContent } from "@/app/_module/components/ui/card";
import type { ReferralStats, RewardStats } from "@/app/_module/services/referralService";

interface RewardsStatsProps {
  stats: ReferralStats;
  rewards?: RewardStats;
}

export default function RewardsStats({ stats, rewards }: RewardsStatsProps) {
  const freeMonths = rewards?.freeMonthsEarned ?? stats.totalConversions;

  const cards = [
    {
      label: "Link Clicks",
      value: stats.totalClicks,
      icon: MousePointerClick,
      color: "text-blue-600",
      bg: "bg-blue-50",
    },
    {
      label: "Sign Ups",
      value: stats.totalSignups,
      icon: UserPlus,
      color: "text-green-600",
      bg: "bg-green-50",
    },
    {
      label: "Conversions",
      value: stats.totalConversions,
      icon: Trophy,
      color: "text-amber-600",
      bg: "bg-amber-50",
    },
    {
      label: "Free Months Earned",
      value: freeMonths,
      icon: Gift,
      color: "text-purple-600",
      bg: "bg-purple-50",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <Card key={card.label}>
          <CardContent className="pt-4 pb-4">
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 rounded-lg ${card.bg} flex items-center justify-center flex-shrink-0`}>
                <card.icon className={`h-5 w-5 ${card.color}`} />
              </div>
              <div>
                <p className="text-2xl font-bold text-gray-900">{card.value}</p>
                <p className="text-xs text-gray-500">{card.label}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
